import { UI_PRIMITIVE__checkbox } from '@/components/ui/UI_PRIMITIVE__checkbox';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_g_inputs__filter_set } from '@/state/ui/generation/LOCAL__ui_g_inputs__filter_set';
import { CheckedState } from '@radix-ui/react-checkbox';
import { DTO__generation_inputs_filter } from '@shared/dto/generation/DTO__generation_inputs_filter';

/**
 * Keys of PAYLOAD__generation_inputs_filter that store Set values
 */
type TYPE__set_filter_keys = {
  [K in keyof DTO__generation_inputs_filter]: DTO__generation_inputs_filter[K] extends Set<infer T> ? K : never;
}[keyof DTO__generation_inputs_filter];

interface FilterCheckboxesProps<K extends TYPE__set_filter_keys> {
  label: string;
  filter_key: K;
  values_all: string[];
}

export function G_LIST_OF_CHECKBOXES__filter_generation_inputs<K extends TYPE__set_filter_keys>({
  label,
  filter_key: filterKey,
  values_all,
}: FilterCheckboxesProps<K>) {
  const dispatch = use_dispatch();
  const { g_inputs__filter } = use_slice_ui(['g_inputs__filter']);

  /*
   *
   */

  // Current Set stored in UI state
  const set__current = g_inputs__filter[filterKey] as Set<string>;

  /*
   *
   */

  function onCheckedChange(checked: CheckedState, valuesToToggle: string[]) {
    if (typeof checked !== 'boolean') return;

    const set_new = new Set(set__current);

    for (const val of valuesToToggle) {
      checked ? set_new.add(val) : set_new.delete(val);
    }

    const filter_new = g_inputs__filter.clone({ [filterKey]: set_new });

    dispatch(LOCAL__ui_g_inputs__filter_set(filter_new));
  }

  function render_item(value: string | 'all') {
    const id = `${filterKey}_${value}`;

    let is_checked: boolean;
    let values_to_toggle: string[];

    if (value === 'all') {
      is_checked = set__current.is_equal(values_all.to_set());
      values_to_toggle = values_all;
    } else {
      is_checked = set__current.has(value);
      values_to_toggle = [value];
    }

    return (
      <div
        key={id}
        className={`flex items-center gap-1 px-2 w-full py-0.5 rounded-sm cursor-pointer border ${
          is_checked ? 'border-component-item-selected' : 'border-transparent'
        }`}
      >
        <UI_PRIMITIVE__checkbox id={id} checked={is_checked} onCheckedChange={(c: CheckedState) => onCheckedChange(c, values_to_toggle)} />
        <label htmlFor={id} className="flex-1 text-xs text-component-item-foreground truncate cursor-pointer">
          {value}
        </label>
      </div>
    );
  }

  const values_sorted = values_all.sort();

  /*
   *
   */

  return (
    <div
      className="flex flex-col w-full
    border-b border-component-border last:border-none
    
    "
    >
      <div className="text-xs text-bar-foreground px-2 py-1 ">{label}</div>
      <div className="flex flex-col gap-0.5 bg-component px-2">
        {render_item('all')}
        {values_sorted.map(render_item)}
      </div>
    </div>
  );
}
